/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { Form, FormGroup, Input, Label } from 'reactstrap';
import React from 'react';

interface ReferralFormParams {
  updateForm: (key: string, value: string) => void;
  form: Record<string, string>;
  disabled?: boolean;
}

export const ReferralForm = ({ updateForm, disabled, form }: ReferralFormParams) => {
  return <Form className='my-5'>
    <div className='row mb-4'>
      <div className='col'>
        <FormGroup disabled={disabled}>
          <Label for='referenceCompany' className='d-block form-check-label strong'>
            Who introduced you to this service?
          </Label>
          <Input
            id='referenceCompany'
            name='referenceCompany'
            type='text'
            placeholder={'Referring company name'}
            onChange={(e) => updateForm('referenceCompany', e.target.value)}
            defaultValue={form.referenceCompany}
            className='mt-2'
          />
          <p className='mt-1'>Optional</p>
        </FormGroup>
      </div>
    </div>
    <div className='row mb-4'>
      <div className='col'>
        <FormGroup>
          <Label for='referralCode' className='d-block form-check-label strong'>Enter your referral code</Label>
          <Input
            placeholder='Referral code'
            id='referralCode'
            name='referralCode'
            type='text'
            onChange={(e) => updateForm(e.target.name, e.target.value)}
            defaultValue={form.referralCode}
            className='mt-2'
          />
          <p className='mt-1'>If you were given one</p>
        </FormGroup>
      </div>
    </div>
  </Form>;
};
